"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var jsx_runtime_1 = require("react/jsx-runtime");
//Config
//Input data
//
var react_1 = require("react");
var code_layer_1 = __importDefault(require("./code-layer/code-layer"));
var invoice_metadatav2_1 = __importDefault(require("./invoice-metadata/invoice-metadatav2"));
var react_2 = require("@chakra-ui/react");
var ui_common_1 = require("@codametrix/ui-common");
var ui_common_2 = require("@codametrix/ui-common");
var ui_components_1 = require("@codametrix/ui-components");
var lookup_1 = require("./lookup/lookup");
var show_results_1 = require("../transactions/transaction/show-results");
var ui_common_3 = require("@codametrix/ui-common");
var invoice_card_1 = __importDefault(require("./invoice-components/invoice-card"));
var test_fixtures_1 = require("@codametrix/test-fixtures");
var SortAndMap_1 = require("../../utils/SortAndMap");
var svg_icons_1 = __importDefault(require("../svgs/svg-icons"));
var changeValueAtPath = ui_common_3.workBench.pathUtils.changeValueAtPath;
var _a = ui_common_3.AmplifyCore.transactionUpdateDTOFactory.codePredicates, isSelectionCPT = _a.isSelectionCPT, isSelectionICD = _a.isSelectionICD, isSelectionModifier = _a.isSelectionModifier;
var draggedCodesManager = ui_common_1.dragManager.load('codes');
var vanillaProcedure = test_fixtures_1.CQAFixtures.CQATaskCodeFixtures.vanillaProcedure;
var FieldType = ui_common_2.commonEnums.FieldType;
var ChargeSessionCodeType = ui_common_2.commonEnums.ChargeSessionCodeType;
var isCodeUniqueInCQATransaction = function (codeInfo, transaction) {
    if (isSelectionCPT(codeInfo)) {
        return !transaction.procedures.find(function (code) { return code.code === codeInfo.code; });
    }
    if (isSelectionICD(codeInfo)) {
        return !transaction.diagnoses.find(function (code) { return code.code === codeInfo.code; });
    }
    if (isSelectionModifier(codeInfo)) {
        return !transaction.modifiers.find(function (code) { return code.code === codeInfo.code; });
    }
    return true;
};
function attachHandlersToFields(fields, transaction, invoice, codeType, onChange, onCodeEvent, deleteCQACode) {
    return fields.map(function (field) {
        if (field.fieldType == FieldType.SelectList) {
            var handleUpdate = function (key, value, values) {
                var update = {
                    selection: value,
                    context: {
                        value: values,
                        field: field,
                        fields: fields,
                        transaction: transaction
                    }
                };
                onChange(update);
            };
            return __assign(__assign({}, field), { onSelect: handleUpdate });
        }
        if (field.fieldType == FieldType.Code) {
            var handleDelete = function (values) {
                var update = {
                    code: __assign({}, values),
                    codeType: codeType,
                    context: { transaction: transaction, invoice: invoice }
                };
                deleteCQACode(update);
            };
            return __assign(__assign({}, field), { onCodeDelete: handleDelete });
        }
        if (field.fieldType == FieldType.TextInput) {
            var handleTextChange = function (units, value, field) {
                var update = {
                    //parseInt(ev.key)
                    code: __assign(__assign(__assign({}, vanillaProcedure), value), { units: units }),
                    context: {
                        value: value,
                        field: field,
                        fields: fields,
                        transaction: transaction
                    }
                };
                onCodeEvent(update);
            };
            return __assign(__assign({}, field), { onKeyPress: handleTextChange });
        }
        return field;
    });
}
var Transaction = function (props) {
    var _a, _b;
    var invoice = props.invoice, transaction = props.transaction, codeSearch = props.codeSearch, cptFields = props.cptFields, icdFields = props.icdFields, modifierFields = props.modifierFields, onCodeEvent = props.onCodeEvent, onChange = props.onChange, onCodeRemove = props.onCodeRemove, onDeleteCQATransaction = props.onDeleteCQATransaction, projectConfiguration = props.projectConfiguration, cqaCodeAssessmentRiskDictionaries = props.cqaCodeAssessmentRiskDictionaries;
    var cptFieldsWithHandlers = attachHandlersToFields(cptFields, transaction, invoice, 'procedure', onChange, onCodeEvent, onCodeRemove);
    var icdFieldsWithHandlers = attachHandlersToFields(icdFields, transaction, invoice, 'diagnosis', onChange, onCodeEvent, onCodeRemove);
    var modifierFieldsWithHandlers = attachHandlersToFields(modifierFields, transaction, invoice, 'modifier', onChange, onCodeEvent, onCodeRemove);
    var codeLayerClassNames = ['standard-code-layer', 'code-row'];
    var cptItems = (0, SortAndMap_1.sortAndMap)({
        array: transaction.procedures,
        sortKey: 'sequenceNumber',
        mapCallback: function (cpt, index) { return ({
            key: "cpt-".concat(index),
            fields: cptFieldsWithHandlers,
            values: __assign(__assign({}, cpt), { codeType: 'procedure' }),
            classNames: __spreadArray(__spreadArray([], __read(codeLayerClassNames), false), [
                cpt.codeAssessment
                    ? 'selected-code-assessment'
                    : 'select-code-assessment'
            ], false),
            draggable: projectConfiguration.procedure,
            transactionId: transaction.id,
            cqaCodeAssessmentRiskDictionaries: cqaCodeAssessmentRiskDictionaries
        }); }
    });
    var icdItems = (0, SortAndMap_1.sortAndMap)({
        array: transaction.diagnoses,
        sortKey: 'sequenceNumber',
        mapCallback: function (icd, index) { return ({
            key: "icd-".concat(index),
            fields: icdFieldsWithHandlers,
            values: __assign(__assign({}, icd), { codeType: 'diagnosis' }),
            classNames: __spreadArray(__spreadArray([], __read(codeLayerClassNames), false), [
                icd.codeAssessment
                    ? 'selected-code-assessment'
                    : 'select-code-assessment'
            ], false),
            draggable: projectConfiguration.diagnosis,
            transactionId: transaction.id,
            cqaCodeAssessmentRiskDictionaries: cqaCodeAssessmentRiskDictionaries
        }); }
    });
    var modifierItems = (0, SortAndMap_1.sortAndMap)({
        array: transaction.modifiers,
        sortKey: 'sequenceNumber',
        mapCallback: function (modifier, index) { return ({
            key: "modifier-".concat(index),
            fields: modifierFieldsWithHandlers,
            values: __assign(__assign({}, modifier), { codeType: 'modifier' }),
            classNames: __spreadArray(__spreadArray([], __read(codeLayerClassNames), false), [
                modifier.codeAssessment
                    ? 'selected-code-assessment'
                    : 'select-code-assessment'
            ], false),
            draggable: projectConfiguration.modifier,
            transactionId: transaction.id,
            cqaCodeAssessmentRiskDictionaries: cqaCodeAssessmentRiskDictionaries
        }); }
    });
    var lookupRef = (0, react_1.useRef)(null);
    var searchResults = (_b = (_a = codeSearch === null || codeSearch === void 0 ? void 0 : codeSearch.searchResults) === null || _a === void 0 ? void 0 : _a[transaction.id]) !== null && _b !== void 0 ? _b : [];
    var onSearch = function (codeQuery) {
        props.codeSearch.onCodeSearch(__assign(__assign({}, codeQuery), { context: {
                transaction: __assign({}, transaction)
            } }));
    };
    var onCodeSelect = function (codeInfo) {
        var isUnique = isCodeUniqueInCQATransaction(codeInfo, transaction);
        if (!isUnique) {
            return;
        }
        props.codeSearch.onCodeSearchSelection(__assign(__assign({}, codeInfo), { context: {
                transaction: __assign({}, transaction)
            } }));
    };
    var handleCodeResequence = function (action) {
        if (!action.dropCandidate || !action.dropTarget) {
            return;
        }
        onCodeEvent({
            code: __assign(__assign({}, action.dropCandidate), { sequenceNumber: action.dropTarget.sequenceNumber }),
            context: {
                transaction: __assign({}, transaction)
            }
        });
    };
    var canDropInto = function (item1, item2, position, allItems) {
        if (item1.codeType == item2.codeType &&
            item1.transactionId == item2.transactionId) {
            return true;
        }
        else {
            return false;
        }
    };
    var onRemoveTransactionClick = function (invoiceId, transactionId, original) {
        onDeleteCQATransaction({ invoiceId: invoiceId, transactionId: transactionId, original: original });
    };
    var procedure = projectConfiguration.procedure, diagnosis = projectConfiguration.diagnosis, modifier = projectConfiguration.modifier;
    var hasProcedureCodes = transaction.procedures.length > 0;
    //Display Procedure Lookup if procedure are active for the project and there is not a procedure code yet
    var incorrectCPTCount = transaction.procedures.filter(function (code) {
        var _a;
        return ((_a = cqaCodeAssessmentRiskDictionaries.procedure.rows.find(function (row) { var _a; return row.assessment == ((_a = code === null || code === void 0 ? void 0 : code.codeAssessment) === null || _a === void 0 ? void 0 : _a.assessment); })) === null || _a === void 0 ? void 0 : _a.category) == 'INCORRECT';
    }).length;
    var correctOrNeutralCPTCount = transaction.procedures.filter(function (code) {
        var _a;
        return ((_a = cqaCodeAssessmentRiskDictionaries.procedure.rows.find(function (row) { var _a; return row.assessment == ((_a = code === null || code === void 0 ? void 0 : code.codeAssessment) === null || _a === void 0 ? void 0 : _a.assessment); })) === null || _a === void 0 ? void 0 : _a.category) !== 'INCORRECT' || (code === null || code === void 0 ? void 0 : code.codeAssessment) == null;
    }).length;
    // caseEvaluationLevel is driven by an option on the CQA collection/rule.
    // ML models need support for case level and charge level grading. In case
    // level grading a grader can link several procedures on the same transaction/charge,
    // so in this case cpt search is always made availble. If case caseEvaluationLevel
    // is set to false then the default functionality is understood as charge level grading.
    var displayCPTLookup = procedure &&
        (transaction.procedures.length == 0 ||
            incorrectCPTCount > correctOrNeutralCPTCount ||
            projectConfiguration.caseEvaluationLevel);
    //Display ICD Lookup if diagnosis are active for the project and the transaction has a CPT Code
    var displayICDLookup = diagnosis && (hasProcedureCodes || !procedure);
    //Display MOD Lookup if modifier are active for the project and the transaction has a Modifier Code
    var displayMODLookup = modifier && (hasProcedureCodes || !procedure);
    return (
    //Grade-bench-panel shares the invoice card with code-bench-panel-v2
    (0, jsx_runtime_1.jsxs)(invoice_card_1["default"], __assign({ additionalClasses: [
            'codable-invoice',
            'qa-codable-invoice',
            'transaction-card',
            'gradeable-transaction'
        ] }, { children: [(0, jsx_runtime_1.jsxs)(react_2.Box, __assign({ className: "code-row charge-text" }, { children: [(0, jsx_runtime_1.jsxs)("span", __assign({ className: "code-header-row" }, { children: ["Charge ", transaction.sequenceNumber] })), !transaction.original && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "charge-remove" }, { children: (0, jsx_runtime_1.jsx)("button", __assign({ className: "charge-remove-btn", onClick: function () {
                                return onRemoveTransactionClick(invoice.id, transaction.id, transaction.original);
                            } }, { children: "remove" })) })))] })), (0, jsx_runtime_1.jsx)(ui_components_1.DraggableList, { items: cptItems, itemComponent: code_layer_1["default"], onDropHandler: handleCodeResequence, canDropOnto: canDropInto, droppable: true, dragManager: draggedCodesManager, dataKey: 'values' }), displayCPTLookup && codeSearch && ((0, jsx_runtime_1.jsx)(lookup_1.Lookup, { ref: lookupRef, actionPrefix: "", placeholderText: 'Select procedure', debounceTimeout: 30, FieldDefinitions: [{ label: 'Procedure', value: 'cpt', key: 'CPT' }], shouldShowResults: show_results_1.shouldShowResults, autoFocus: transaction.sequenceNumber == 1, onSearch: onSearch, onSearchSelection: onCodeSelect, searchResults: searchResults, SearchBarViewVersion: 'SearchBarView2' })), (0, jsx_runtime_1.jsx)(ui_components_1.DraggableList, { items: icdItems, itemComponent: code_layer_1["default"], onDropHandler: handleCodeResequence, canDropOnto: canDropInto, droppable: true, dragManager: draggedCodesManager, dataKey: 'values' }), displayICDLookup && codeSearch && ((0, jsx_runtime_1.jsx)(lookup_1.Lookup, { ref: lookupRef, actionPrefix: "", placeholderText: 'Select diagnosis', debounceTimeout: 30, FieldDefinitions: [{ label: 'Diagnosis', value: 'icd', key: 'ICD' }], shouldShowResults: show_results_1.shouldShowResults, autoFocus: false, onSearch: onSearch, onSearchSelection: onCodeSelect, searchResults: searchResults, SearchBarViewVersion: 'SearchBarView2' })), (0, jsx_runtime_1.jsx)(ui_components_1.DraggableList, { items: modifierItems, itemComponent: code_layer_1["default"], onDropHandler: handleCodeResequence, canDropOnto: canDropInto, droppable: true, dragManager: draggedCodesManager, dataKey: 'values' }), displayMODLookup && codeSearch && ((0, jsx_runtime_1.jsx)(lookup_1.Lookup, { ref: lookupRef, actionPrefix: "", placeholderText: 'Select modifier', debounceTimeout: 30, FieldDefinitions: [
                    { label: 'Modifier', value: 'modifier', key: 'MODIFIER' }
                ], shouldShowResults: show_results_1.shouldShowResults, autoFocus: false, onSearch: onSearch, onSearchSelection: onCodeSelect, searchResults: searchResults, SearchBarViewVersion: 'SearchBarView2' }))] }), "transaction-".concat(transaction.sequenceNumber)));
};
var GradeBenchPanelGeneralized = function (props) {
    // Return grade-benchgroup
    var gradeableInvoices = props.gradeableInvoices, codeSearch = props.codeSearch, invoiceMetadataFields = props.invoiceMetadataFields, cptFields = props.cptFields, icdFields = props.icdFields, modifierFields = props.modifierFields, onCodeUpdate = props.onCodeUpdate, onCodeRemove = props.onCodeRemove, onCodeEvent = props.onCodeEvent, riskCategories = props.riskCategories, cqaCodeAssessmentRiskDictionaries = props.cqaCodeAssessmentRiskDictionaries, _a = props.projectConfiguration, projectConfiguration = _a === void 0 ? ui_common_1.AmplifyState.defaultQARule.data
        .project_configuration : _a, onCreateCQATransaction = props.onCreateCQATransaction, onDeleteCQATransaction = props.onDeleteCQATransaction, gradingErrors = props.gradingErrors;
    var invoiceItems = gradeableInvoices.map(function (invoice, invoiceIndex) {
        var _a, _b;
        var attachInvoiceToUpdate = function (update) {
            update.context['invoice'] = invoice;
            update.context.riskCategories = riskCategories;
            onCodeUpdate(__assign({}, update));
        };
        var codeSearchWithInvoice = __assign(__assign({}, codeSearch), { onCodeSearchSelection: function (codeInfo) {
                codeInfo.context.invoice = invoice;
                codeSearch.onCodeSearchSelection(codeInfo);
            } });
        var onCodeEventWithInvoice = function (codeUpdate) {
            codeUpdate.context.invoice = invoice;
            onCodeEvent(codeUpdate);
        };
        var onAddTransactionClick = function (invoice) {
            onCreateCQATransaction({ invoiceId: invoice.id });
        };
        var txs = invoice.transactions.map(function (transaction, index) {
            return ((0, jsx_runtime_1.jsx)(Transaction, { invoice: invoice, transaction: transaction, codeSearch: codeSearchWithInvoice, cptFields: cptFields, icdFields: icdFields, modifierFields: modifierFields, onChange: attachInvoiceToUpdate, onCodeRemove: onCodeRemove, projectConfiguration: projectConfiguration, onCodeEvent: onCodeEventWithInvoice, onDeleteCQATransaction: onDeleteCQATransaction, cqaCodeAssessmentRiskDictionaries: cqaCodeAssessmentRiskDictionaries }, "transaction-".concat(index + 1, "-group")));
        });
        invoice.transactions.sort(function (t1, t2) { return t1.sequenceNumber - t2.sequenceNumber; });
        return {
            headerText: (_a = invoice['dateOfService']) !== null && _a !== void 0 ? _a : '',
            subheaderText: (_b = invoice['billingProviderName']) !== null && _b !== void 0 ? _b : '',
            body: ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "invoice-meta" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "invoice-meta-line invoice-meta-provider" }, { children: [(0, jsx_runtime_1.jsx)(invoice_metadatav2_1["default"], { fields: invoiceMetadataFields, invoice: invoice, editable: false }), txs] })), !projectConfiguration.caseEvaluationLevel && ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "add-transaction", onClick: function () { return onAddTransactionClick(invoice); } }, { children: [(0, jsx_runtime_1.jsxs)("button", __assign({ className: "add-transaction-btn" }, { children: [(0, jsx_runtime_1.jsx)(svg_icons_1["default"], { svgIconName: 'PlusSign1', svgIconClass: '', svgIconSize: '16', svgViewBox: '16' }), (0, jsx_runtime_1.jsx)("span", { children: "\u00A0 Add transaction" })] })), gradingErrors.addTransaction && ((0, jsx_runtime_1.jsx)("small", __assign({ className: "add-transaction-error" }, { children: "error adding transaction" })))] }), "add-transaction-".concat(invoiceIndex)))] }), invoiceIndex))
        };
    });
    return ((0, jsx_runtime_1.jsx)(react_2.Box, __assign({ className: "code-bench-panelv2 grade-bench-panel" }, { children: (0, jsx_runtime_1.jsx)(ui_components_1.HorizontalTabContainer, { items: invoiceItems }) })));
};
exports["default"] = GradeBenchPanelGeneralized;
//# sourceMappingURL=grade-bench-panel-generalized.js.map